import { useState } from 'react';
import { getClientUserList } from 'services/CaseServices';

export function useCaseUserClientDetails() {
  const [caseUserClientList, setCaseUserClientList] = useState([]);

  const loadCaseUserClientDetails = async (
    caseId,
    is_contact_list = false,
    is_team_member_list = false,
    all_contacts = false,
    contact_id = false,
    is_lead = false,
    is_mandatory_lawft_access = false,
    is_active = false,
    is_include_groups = false,
    active_groups = false
  ) => {
    if (!caseId) return;

    try {
      const response = await getClientUserList(
        caseId,
        is_contact_list,
        is_team_member_list,
        all_contacts,
        contact_id,
        is_lead,
        is_mandatory_lawft_access,
        is_active,
        is_include_groups,
        active_groups
      );
      setCaseUserClientList(response?.data || []);
    } catch (error) {
      console.error('Error fetching client user list:', error);
    }
  };

  return {
    caseUserClientList,
    loadCaseUserClientDetails,
  };
}
